import configureEnvironment from '@sbvr/lbe-environment';
configureEnvironment();
